import React, { useState } from 'react';

const HistoryPage = () => {
  const [history, setHistory] = useState();

  const handleClearHistory = () => {
    setHistory([]);
  };

  const containerStyle = {
    width: '90%',
    maxWidth: '600px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  };

  const headerStyle = {
    fontSize: '24px',
    marginBottom: '20px',
  };

  const buttonStyle = {
    backgroundColor: '#ff4d4d',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    fontSize: '16px',
    width: '100%',
  };

  const buttonHoverStyle = {
    backgroundColor: '#ff1a1a',
  };

  const listStyle = {
    listStyleType: 'none',
    padding: '0',
  };

  const listItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    borderBottom: '1px solid #ddd',
  };

  const lastItemStyle = {
    borderBottom: 'none',
  };

  const imageStyle = {
    width: '100px',
    height: '100px',
    marginRight: '20px',
    borderRadius: '5px',
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  };

  const dateStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const descriptionStyle = {
    color: '#555',
    marginBottom: '5px',
  };

  const statusStyle = {
    color: 'green',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Order History</h1>
      <ul style={listStyle}>
        {history.length === 0 ? (
          <li style={listItemStyle}>No history available</li>
        ) : (
          history.map((item, index) => (
            <li
              key={item.id}
              style={{ ...listItemStyle, ...(index === history.length - 1 ? lastItemStyle : {}) }}
            >
              <img src={item.image} alt={item.description} style={imageStyle} />
              <div style={contentStyle}>
                <span style={descriptionStyle}>{item.description}</span>
                <span style={dateStyle}>{item.date}</span>
                <span style={statusStyle}>{item.status}</span>
              </div>
            </li>
          ))
        )}
      </ul>
      <button
        onClick={handleClearHistory}
        style={buttonStyle}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = buttonHoverStyle.backgroundColor}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
      >
        Clear History
      </button>
    </div>
  );
};

export default HistoryPage;
